import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';

export const usePassengerAppNavigate = () => {
	const navigate = useNavigate();

	const navigateBack = useCallback(() => navigate(-1), [navigate]);

	const navigateToHome = useCallback(
		(options?: NavigateOptions) => navigate('/home', options),
		[navigate]
	);

	const navigateToUserDTicket = useCallback(
		(options?: NavigateOptions) => navigate('/user-dticket', options),
		[navigate]
	);

	const navigateToSubscriptionPause = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/subscription-pause', options),
		[navigate]
	);

	// TODO: redesign-dticket - rename to navigateToDTicketEditPause ?
	const navigateToSubscriptionEditPause = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/edit-pause', options),
		[navigate]
	);

	const navigateToResumeSubscription = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/resume-subscription', options),
		[navigate]
	);

	const navigateToSubscriptionCancel = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/subscription-cancel', options),
		[navigate]
	);

	const navigateToSubscriptionEdit = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/subscription-edit', options),
		[navigate]
	);

	const navigateToDownloadInvoices = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/download-invoices', options),
		[navigate]
	);

	const navigateToSubscribeDTicket = useCallback(
		(options?: NavigateOptions) => navigate('/subscribe-dticket', options),
		[navigate]
	);

	const navigateToEditPaymentMethod = useCallback(
		(options?: NavigateOptions) =>
			navigate('/user-dticket/edit-payment-method', options),
		[navigate]
	);

	const navigateToTicketshop = useCallback(
		(options?: NavigateOptions) => navigate('/ticketshop', options),
		[navigate]
	);

	const navigateToOperatorTickets = useCallback(
		(operatorId: string, options?: NavigateOptions) =>
			navigate(`/ticketshop/${operatorId}`, options),
		[navigate]
	);

	const navigateToOperatorTicketsWithName = useCallback(
		(operatorId: string, operatorName: string, options?: NavigateOptions) =>
			navigate(`/ticketshop/${operatorId}`, {
				...options,
				state: { ...(options?.state ?? {}), operatorName },
			}),
		[navigate]
	);

	const navigateToOperatorTicketDetail = useCallback(
		(
			operatorId: string,
			ticketId: string,
			extras?: {
				operatorName?: string;
				tariffConditionsUrl?: string;
				priceGroupId?: string;
			},
			options?: NavigateOptions
		) =>
			navigate(`/ticketshop/${operatorId}/tickets/${ticketId}`, {
				...options,
				state: { ...(options?.state ?? {}), ...(extras ?? {}) },
			}),
		[navigate]
	);

	const navigateToMyTicketDetail = useCallback(
		(purchaseId: string, options?: NavigateOptions) =>
			navigate(`/ticketshop/my-tickets/${purchaseId}`, options),
		[navigate]
	);

	const navigateToChipcardRequest = useCallback(
		(purchaseId: string, options?: NavigateOptions) =>
			navigate(`/ticketshop/my-tickets/${purchaseId}/chipcard`, options),
		[navigate]
	);

	const navigateToManageBillingAddress = useCallback(
		(options?: NavigateOptions) =>
			navigate(
				'/user-dticket/download-invoices/manage-billing-address',
				options
			),
		[navigate]
	);

	return {
		navigateBack,
		navigateToHome,
		navigateToUserDTicket,
		navigateToSubscriptionPause,
		navigateToSubscriptionEditPause,
		navigateToResumeSubscription,
		navigateToSubscriptionCancel,
		navigateToSubscriptionEdit,
		navigateToDownloadInvoices,
		navigateToSubscribeDTicket,
		navigateToEditPaymentMethod,
		navigateToTicketshop,
		navigateToOperatorTickets,
		navigateToOperatorTicketsWithName,
		navigateToOperatorTicketDetail,
		navigateToMyTicketDetail,
		navigateToChipcardRequest,
		navigateToManageBillingAddress,
	};
};
